interface Comment {
  avatar: string;
  name: string;
  time: string;
  content: string;
  manga: string;
}

const COMMENTS: Comment[] = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20young%20man%20portrait%20avatar%2C%20simple%20background%2C%20warm%20lighting%2C%20friendly%20expression%2C%20clean%20illustration%20style&width=200&height=200&seq=avatar-01&orientation=squarish',
    name: '二次元老司机',
    time: '3小时前',
    content: '追了我独自升级两年了，每次更新都看得热血沸腾！画风太炸裂了，战斗分镜简直封神。土豪漫画的更新速度真的快，比其他平台早半天就能看到，爱了爱了。',
    manga: '我独自升级',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20young%20woman%20portrait%20avatar%2C%20simple%20background%2C%20soft%20lighting%2C%20gentle%20smile%2C%20clean%20illustration%20style&width=200&height=200&seq=avatar-02&orientation=squarish',
    name: '樱花飘落时',
    time: '6小时前',
    content: '从日漫入坑到现在已经在这个站看了三年了，资源真的太全了。冷门老番都能找到，而且页面干净没有乱七八糟的弹窗广告，阅读体验一级棒。',
    manga: '咒术回战',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20teenage%20boy%20portrait%20avatar%2C%20simple%20background%2C%20bright%20lighting%2C%20energetic%20expression%2C%20clean%20illustration%20style&width=200&height=200&seq=avatar-03&orientation=squarish',
    name: '漫画小王子',
    time: '12小时前',
    content: '国漫这几年真的起飞了！一人之下、镇魂街都追到最新了，土豪漫画的国漫分类做得很好，每周更新都有醒目提醒，再也不用担心漏看了。',
    manga: '一人之下',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20girl%20portrait%20avatar%20with%20glasses%2C%20simple%20background%2C%20warm%20tone%2C%20smart%20look%2C%20clean%20illustration%20style&width=200&height=200&seq=avatar-04&orientation=squarish',
    name: '追更少女',
    time: '1天前',
    content: '韩漫的恋爱剧情太会上头了！女神降临完结后又开始追外貌至上主义，每一部都好磕。希望能多上一些完结韩漫，一次性看完的感觉太爽了～',
    manga: '女神降临',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-50 scroll-mt-[72px]">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">读者热评</h2>
          <p className="text-foreground-500 text-sm mt-3">真实读者的阅读感受，看看大家都在聊什么</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-5xl mx-auto">
          {COMMENTS.map((comment) => (
            <div
              key={comment.name}
              className="bg-background-100 rounded-xl border border-background-200/70 p-5 flex gap-4"
            >
              <img
                src={comment.avatar}
                alt={comment.name}
                className="w-11 h-11 rounded-full object-cover shrink-0"
              />
              <div className="min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <span className="text-sm font-semibold text-foreground-900">{comment.name}</span>
                  <span className="text-xs text-foreground-400">{comment.time}</span>
                  <span className="text-xs px-2 py-0.5 rounded-md bg-primary-100 text-primary-700 font-medium">
                    {comment.manga}
                  </span>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}